import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Active Orders (Admin)
export const getActiveOrders = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-active-orders", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params, // لو في فلترة مستقبلًا
      },
    });

    return res.data;
    // { data: [...orders], message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Tables With Orders (Public)
export const getTablesWithOrders = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/public/get-tables-with-orders", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params,
      },
    });

    return res.data;
    // { data: [...tables] }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Order Details (Admin)
export const getOrderDetails = async (id) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get(`/admin/get-order-details/${id}`, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    // { data: {...order}, message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Create Order (Admin) - JSON body
export const createOrder = async (payload) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const res = await api.post("/user/create-order", payload, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; // { order_id, status }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Closed Orders (Admin)
export const getClosedOrders = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-closed-orders", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params,
      },
    });

    return res.data; 
    // { data: [...orders], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Order Customer (Admin) - JSON body
export const updateOrderCustomer = async ({
  customerId: CustomerId,
  name,
  phone,
  email,
  address,
  address2,
  address3,
  phone2,
  phone3,
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const body = {
    name: String(name || ""),
    phone: String(phone || ""),
    email: email == null ? null : String(email || ""),
    address: address == null ? null : String(address || ""),
    address2: address2 == null ? null : String(address2 || ""),
    address3: address3 == null ? null : String(address3 || ""),
    phone2: phone2 == null ? null : String(phone2 || ""),
    phone3: phone3 == null ? null : String(phone3 || ""),
  };

  try {
    const res = await api.post(
      `/admin/update-order-customer/${CustomerId}`,
      body,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data; // { data: {...customer}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Delete Order (Admin)
export const deleteOrder = async (order_id) => {
  const headers = {
    ...getAuthHeaders(), // Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/delete-order/${order_id}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data; 
    // { data: null, message: "تم حذف الطلب بنجاح" }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

export const updateOrderItem = async (data) => {
  const res = await api.post(
    "/admin/update-order-item",
    data,
    {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    }
  );

  return res.data;
};

export const addOrderItems = async (data) => {
  const res = await api.post(
    "/admin/add-order-items",
    data,
    {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    }
  );

  return res.data;
};
// ✅ Delete Order Item
export const deleteOrderItem = async (item_id) => {
  const headers = {
    ...getAuthHeaders(), // Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/delete-order-item/${item_id}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    // { data: [], message: "تم حذف العنصر بنجاح" }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Close Order Item Time
export const closeOrderItemTime = async (item_id) => {
  const headers = {
    ...getAuthHeaders(), // Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/close-order-item-time/${item_id}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    // { data: [], message: "تم تعديل العنصر بنجاح" }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Order (Admin) - JSON body
export const updateOrder = async ({
  order_id,
  status,
  table_id,
  captain_order_id,
  delivery_id,
  date,
  order_type,
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  
  const body = {
    status: status ?? undefined,
    table_id: table_id ?? null,
    captain_order_id: captain_order_id ?? null,
    delivery_id: delivery_id ?? null,
    date: date ?? undefined,
    order_type: order_type ?? undefined,
  };

  // ✅ شيل undefined عشان مايبعتش حقول فاضية
  Object.keys(body).forEach((k) => body[k] === undefined && delete body[k]);

  try {
    const res = await api.post(`/admin/update-order/${order_id}`, body, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; // { data: {...order}, message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
